import { Component, ElementRef, ViewChild , OnInit} from '@angular/core';
import { trigger, style, transition, animate, AnimationEvent } from '@angular/animations';
import { MegaMenuItem } from 'primeng/api';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import {LoginService} from './login/login.service';
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({opacity: 0, transform: 'scaleY(0.8)'}),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: '*' })),
              ]),
              transition(':leave', [
                animate('.1s linear', style({ opacity: 0 }))
              ])
        ])
    ]
})
export class AppTopBarComponent implements OnInit  {

    constructor(public appMain: AppMainComponent, public app: AppComponent,public loginService:LoginService) {
    }

    activeItem: number;

    model: MegaMenuItem[];
    
    ngOnInit() {
        this.loginService.loginEmetteur.subscribe((value:any) =>{
            var data = [];
        });
        this.loginService.loginEmetteur.emit({});
    }

    @ViewChild('searchInput') searchInputViewChild: ElementRef;

    onSearchAnimationEnd(event: AnimationEvent) {
        switch(event.toState) {
            case 'visible':
                this.searchInputViewChild.nativeElement.focus();
            break;
        }
    }
    
    logout() {
        this.loginService.logout();
    }
}
